module.exports = __webpack_public_path__ + "static/media/AC08004D_02.2006911f.png";